import { ReactNode } from 'react';
import styled from '@emotion/styled';
import {
	IImagePosition,
	ILinkItemType,
	Responsive,
	StyledHighlightContent,
	Css,
} from '@/ui';
import Card from '../cards/ContentCard/ContentCard';
import { theme } from '../../../styles/theme';
import { Color } from '../../../styles/Color';

export interface IHighlightContentProps {
	title: string;
	body?: ReactNode | string;
	linkHref?: string;
	linkTitle?: string;
	imagePosition?: Responsive.IValueOrResponsiveValue<IImagePosition>;
	linkType?: ILinkItemType;
}

export function HighlightContent({
	title,
	body,
	linkHref,
	linkTitle,
	imagePosition,
	linkType,
}: IHighlightContentProps) {
	return (
		<HighlightContentWrap imagePosition={imagePosition}>
			<StyledContentCardContainer>
				<Card
					title={title}
					body={body}
					buttonLabel={linkTitle}
					buttonLink={linkHref}
					linkType={linkType}
				/>
			</StyledContentCardContainer>
		</HighlightContentWrap>
	);
}

const HighlightContentWrap = styled(StyledHighlightContent)<{
	imagePosition: IHighlightContentProps['imagePosition'];
}>`
	padding-left: ${({ imagePosition }) => {
		if (imagePosition && imagePosition[0] === 'first') return 0;
		return 0;
	}};
	padding-right: ${({ imagePosition }) => {
		if (imagePosition && imagePosition[0] === 'last') return 0;
		return 0;
	}};

	grid-column: ${({ imagePosition }) => {
		if (imagePosition && imagePosition[0] === 'first') return '2 / span 3';
		return '1 / span 2';
	}};

	grid-row: 1;
	z-index: 1;
	min-width: auto;
	max-width: none;

	display: flex;
	flex-direction: column;
	justify-content: center;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-column: 1;
		grid-row: 2 / span 2;
	}
`;

const StyledContentCardContainer = styled.div`
	background-color: ${Color.PrimaryWhite};
	border-radius: ${theme.card?.borderRadius};
	box-shadow: ${theme.card?.fullyClickable?.boxShadow};
	overflow: hidden;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-top: ${Css.pxToRemFromTheme(-100)};
	}
`;
